<template>
	<div class="OpenAccountBox">
		<div class="OpenAccountBoxTop">
			<div class="TitleLeft">
				联系信息
			</div>
			<div class="Btn">
				<Btn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" :title="BtnTitle" :useAutoOptional="false"
					color="#FFFFFF" @btnclick="SubmitFreview"></Btn>
			</div>
			<div class="TitleRight" v-if="Status.UploadFileStatus == 1">
				. 未审核
			</div>
			<!-- <div class="TitleRight" style="color: #424E66;" v-if="Status.UploadFileStatus == 1">
        . 审核中
      </div> -->
			<div class="TitleRight" style="color: #00266d;" v-if="Status.SucceeStatus == 2">
				<div class="spotimg"></div> 审核成功
			</div>
			<div class="TitleRight" style="color: rgb(231, 29, 67);" v-if="Status.SucceeStatus == -1">
				<div class="spotimgerror"></div> 已驳回
			</div>
		</div>
		<div class="TopLine"></div>
		<div class="result" v-if="RejectReason != null">
			<div class="reason">驳回原因</div>
			<div class="reasonText">
				{{ RejectReason }}
			</div>
		</div>
		<Procedure :Status="Status"></Procedure>
		<div>
			<FromComm :FromArr="FromArr"></FromComm>
		</div>
		<div class="line"></div>
		<TipsDialog ref="tipsdig" />
	</div>
</template>

<script>
	import Procedure from './components/procedure.vue'
	import CommonUploadEnclosure from '@/components/common-upload-Enclosure.vue'
	import Btn from '@/components/common-btn'
	import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
	import Picturepreview from '@/components/picturepreview.vue'
	import FromArr from './FormData/FromArr'
	import TipsDialog from '../../components/TipsDialog.vue'
	import {
		OpenAccountAddFileContact,
		OpenAccountGetFileContact
	} from '@/api/channel'
	export default {
		components: {
			Procedure,
			CommonUploadEnclosure,
			Btn,
			Picturepreview,
			FromComm,
			TipsDialog
		},
		props: {},
		data() {
			return {
				FromArr: [],
				BtnTitle: 'loading...',
				RejectReason: '',
				Status: {
					UploadFileStatus: 0,
					ExamineStatus: 0,
					SucceeStatus: 0,
				}
			}
		},
		created() {
			this.OpenAccountGetFileContact()
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
		},
		activated() {},
		updated() {},
		methods: {
			async OpenAccountGetFileContact() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await OpenAccountGetFileContact({})
				if (code == 0) {
					if (data != null) {
						this.FromArr[0].modelvalue = data.fileContact.CompanyChargeName
						this.FromArr[1].modelvalue = data.fileContact.CompanyChargePhone
						this.FromArr[2].modelvalue = data.fileContact.CompanyChargeEmail
						this.FromArr[3].modelvalue = data.fileContact.DataUploadName

						this.FromArr[4].modelvalue = data.fileContact.DataUploadPhone
						this.FromArr[5].modelvalue = data.fileContact.DataUploadEmail
						this.FromArr[6].modelvalue = data.fileContact.DeliveryName
						this.FromArr[7].modelvalue = data.fileContact.DeliverPhone

						this.FromArr[8].modelvalue = data.fileContact.DeliveryAddress
						this.FromArr[9].modelvalue = data.fileContact.InvoiceName
						this.FromArr[10].modelvalue = data.fileContact.InvoicePhone
						this.FromArr[11].modelvalue = data.fileContact.InvoiceAddress
						
						this.FromArr[12].modelvalue = data.fileContact.FileLinkMan
						this.FromArr[13].modelvalue = data.fileContact.FileLinkTel
						this.FromArr[14].modelvalue = data.fileContact.FileEMail
						this.FromArr[15].modelvalue = data.fileContact.FileReceiveAddress
						
						
						
						if (data.Status == 0) {
							this.Status.UploadFileStatus = 1
							this.Status.ExamineStatus = 0
							this.Status.SucceeStatus = 0
							console.log(this.Status);
						} else if (data.Status == 1) {
							this.Status.UploadFileStatus = 2
							this.Status.ExamineStatus = 2
							this.Status.SucceeStatus = 2
						} else if (data.Status == -1) {
							this.Status.UploadFileStatus = 2
							this.Status.ExamineStatus = 2
							this.Status.SucceeStatus = -1
						}
						this.RejectReason = data.RejectReason
						this.BtnTitle = '修改'
					} else {
						this.BtnTitle = '提交审核'
					}
				} else {
					this.$notify({
						title: '提示',
						type: 'warning',
						message: message
					})
				}
				loading.close()
			},
			async OpenAccountAddFileContact() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await OpenAccountAddFileContact({
					CompanyChargeName: this.FromArr[0].modelvalue,
					CompanyChargePhone: this.FromArr[1].modelvalue,
					CompanyChargeEmail: this.FromArr[2].modelvalue,
					DataUploadName: this.FromArr[3].modelvalue,
					DataUploadPhone: this.FromArr[4].modelvalue,
					DataUploadEmail: this.FromArr[5].modelvalue,
					DeliveryName: this.FromArr[6].modelvalue,
					DeliverPhone: this.FromArr[7].modelvalue,
					DeliveryAddress: this.FromArr[8].modelvalue,
					InvoiceName: this.FromArr[9].modelvalue,
					InvoicePhone: this.FromArr[10].modelvalue,
					InvoiceAddress: this.FromArr[11].modelvalue,
					FileLinkMan: this.FromArr[12].modelvalue,
					FileLinkTel: this.FromArr[13].modelvalue,
					FileEMail: this.FromArr[14].modelvalue,
					FileReceiveAddress: this.FromArr[15].modelvalue,
				})
				if (code == 0) {
					this.$notify({
						title: '提示',
						type: 'success',
						message: message
					})
					this.$refs.tipsdig.getData();
					this.OpenAccountGetFileContact()
					this.BtnTitle = '修改'
				} else {
					this.$notify({
						title: '提示',
						type: 'warning',
						message: message
					})
				}
				loading.close()
			},
			SubmitFreview() {
				if (this.BtnTitle == '修改') {
					this.BtnTitle = '提交审核'
				} else if (this.BtnTitle == '提交审核') {
					this.OpenAccountAddFileContact()
				}
			},
		},
		computed: {},
		watch: {
			BtnTitle: {
				handler(newVal, oldVal) {
					if (newVal == '修改') {
						this.FromArr.forEach((item, index) => {
							item.disabled = true
						})
					} else if (newVal == '提交审核') {
						this.FromArr.forEach((item, index) => {
							item.disabled = false
						})
					}
				}
			}
		},
	}
</script>
<style scoped lang='less'>
	.spotimg {
		display: inline-block;
		width: 12.5px;
		height: 10px;
		position: relative;
		right: 5px;
		bottom: 0px;
		background: url("../../../../../assets/channel/menu/OK2.png") no-repeat 0px 0px;
		background-size: 100%;
	}

	.spotimgerror {
		display: inline-block;
		width: 12.5px;
		height: 10px;
		position: relative;
		right: 5px;
		bottom: 0px;
		background: url("../../../../../assets/channel/menu/error1.png") no-repeat 0px 0px;
		background-size: 100%;
	}

	.OpenAccountBox {
		height: 100%;
		width: 910px;
		margin: 0 auto;

		.result {
			width: 100%;

			.reason {
				color: #16181a;
				font-size: 14px;
				font-weight: 500;
				margin: 9px;
			}

			.reasonText {
				width: 872px;
				// height: 32px;
				margin: 0 auto;
				background-color: #fef8f9;
				border: 1px solid #ebedf0;
				color: #e71d43;
				line-height: 32px;
				padding-left: 20px;
				margin-bottom: 30px;
				word-wrap: break-word;
			}
		}

		.OpenAccountBoxTop {
			height: 70px;
			width: 100%;
			border-bottom: 1px solid #eaecef;
			position: relative;

			.TitleLeft {
				height: 45px;
				width: 100%;
				line-height: 45px;
				font-size: 16px;
				font-weight: 500;
				color: #16181a;
				display: inline;
			}

			.TitleRight {
				height: 45px;
				width: 95px;
				line-height: 45px;
				font-size: 14px;
				font-weight: 500;
				color: #9ca5b7;
				position: absolute;
				top: 0;
				right: -30px;
			}
		}

		.fileList {
			width: 100%;
			height: 100%;
			// border: 1px solid red;
			margin-top: 30px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.file {
				line-height: 32px;
				border-radius: 2px;
				border: 1px solid #e6e6e6;
				cursor: pointer;
				display: inline-block;
				position: relative;
				width: 440px;
				height: 32px;
				color: #000000;
				font-size: 12px;
				background-color: #fafbfc;
				margin-top: 10px;

				.fileName {
					display: inline-block;
					font-size: 14px;
					margin-left: 20px;
					max-width: 320px;
					// border: 1px solid red;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.cz {
					display: flex;
					width: 90px;
					font-size: 14px;
					float: right;
					color: #e71d43;

					.fileSee {
						display: inline-block;
						margin-left: 10px;
					}

					.fileDel {
						display: inline-block;
						margin-left: 10px;
					}
				}
			}
		}
	}

	.Upload {
		height: 100%;
		width: 100%;
		//   border: 1px solid red;
		margin-top: 30px;

		.UploadTitle {
			font-size: 14px;
			font-weight: normal;
			color: #424e66;
		}

		.Enclosure {
			margin-left: -45px;
		}

		.Remarks {
			font-size: 14px;
			font-weight: normal;
			color: #9ca5b7;
		}
	}

	.line {
		width: 100%;
		height: 1px;
		background: #eaecef;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: 30px;
	}

	.Btn {
		margin-right: 700px;
		display: inline;
	}
</style>
